import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  enabled: false,
  body: '',
  bodyLabel: () => faker.lorem.words(),
  bodyPlaceholder: () => 'placeholder ' + faker.lorem.words(),
  customTranslations: () => {
    return { body: {}, title: {} };
  },
  iconType: () => faker.image.url(),
  position: (i) => i,
  title: (n) => `${n} ${faker.lorem.words()}`,

  filledIn: trait({
    body: () => faker.lorem.words(),
    enabled: true,
  }),

  withTranslations: trait({
    body: () => faker.lorem.words(),
    afterCreate(section, server) {
      const location = server.schema.locations.first();
      const locales = location ? location.enabledLocales : [];
      locales.forEach((code) => {
        section.customTranslations.body[code] = faker.lorem.words();
        section.customTranslations.title[code] = faker.lorem.words();
      });
    },
  }),
});
